import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useFormConfig } from '../../hooks/useFormConfig';
import ProgressBar from '../ProgressBar/ProgressBar';
import type { Props } from './types';

const GovHeader = styled.header`
    .govuk-width-container {
        border-bottom-color: transparent;
    }

    &.govuk-header {
        border-bottom: 0;
    }
    .govuk-header__container {
        display: block;
    }

    .govuk-header__product-name {
        margin-left: 0.5cm;
    }
`;

function Header({ loading }: Props) {
  const { tenant } = useFormConfig();

  return (
    <GovHeader className="govuk-header" role="banner">
      <div className="govuk-header__container govuk-width-container">
        <div className="govuk-header__logo">
          <Link
            to={tenant ? `/${tenant}` : '/'}
            className="govuk-header__link govuk-header__link--homepage"
          >
            <img src="/images/cod_logo.png" alt="Logo" width="148" height="30" />
            <span className="govuk-header__product-name">GovReturns</span>
          </Link>
        </div>
      </div>
      <ProgressBar loading={loading} />
    </GovHeader>
  );
}

export default Header;

